<div [ngClass]="border ? 'profile-pic-container' : ''">
  @if (type === "user-pic") {
    <div [class.stackable]="allowUpload">
      @if (logoPath) {
        <img
          [ngClass]="size"
          class="profile-pic"
          [src]="logoPath"
          (error)="handleLogoError()"
          alt="User profile picture"
          (mouseenter)="onProfilePicHover(true)"
        />
      } @else {
        <div class="virtual-img {{ size }}">
          {{ getInitial() }}
        </div>
      }
    </div>
  }
</div>
<div class="company-logo-container">
  @if (type === "company-logo") {
    <img
      [ngClass]="size"
      class="company-pic"
      [src]="logoPath"
      onerror="this.onerror=null;this.src='/assets/media/icons/default-company-icon.png';"
      alt="User profile picture"
    />
  }

  <input
    type="file"
    accept="image/*"
    id="img-input"
    (change)="onLogoChange($event)"
    #imgInput
  />
  <div class="company-info-container">
    <span class="company-name">{{ companyName }}</span>
    <span class="office-text">{{ totalOffice }}&nbsp;Offices</span>
  </div>
  @if (isOfficeSettings && isOfficeAdmin(currentUser)) {
    <div class="action-buttons-containter">
      <div class="buttons-container">
        <button
          [disabled]="disableUpload || loading"
          (click)="imgInput.click()"
          type="button"
          class="action-buttons"
          i18n="@@global.upload-photo"
        >
          {{ actionTitle }}
        </button>
        <button
          [disabled]="isRemoveButtonDisabled || loading"
          [ngClass]="{ 'disabled-button': isRemoveButtonDisabled || loading }"
          (click)="onclick()"
          type="button"
          class="action2-buttons"
          i18n="@@global.remove-photo"
        >
          Remove photo
        </button>
      </div>
      @if (!showerrormessage) {
        <span class="logo-info"
          >320px x 320px, PNG or JPG format under 500mb</span
        >
      }
      @if (showerrormessage) {
        <span class="logo-error-message">
          <img
            src="/assets/media/icons/wallet/error1.svg"
            alt="Error"
            class="error-icon"
          />
          File size exceeds limit (500mb, PNG/JPG format)
        </span>
      }
    </div>
  }
</div>
